import React from 'react';

interface MousePointerClickIconProps {
  className?: string;
}

/**
 * MousePointerClick icon – mirrors the lucide-react icon used in the
 * dashboard's "Clicks to book/call" tile. Hand-rolled per design-system rule
 * that landing does not depend on lucide-react.
 *
 * Cursor body + 4 surrounding click "sparkle" strokes. 24x24 viewBox + stroked
 * paths to match the dashboard's visual register; this is the first stroked
 * icon in the landing icon directory (existing icons are 20x20 filled
 * Heroicons-style). Future stroked icons should follow the same convention.
 */
export function MousePointerClickIcon({
  className = 'h-5 w-5',
}: MousePointerClickIconProps): React.ReactElement {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M14 4.1 12 6" />
      <path d="m5.1 8-2.9-.8" />
      <path d="m6 12-1.9 2" />
      <path d="M7.2 2.2 8 5.1" />
      <path d="M9.037 9.69a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z" />
    </svg>
  );
}
